/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import UserSession from '../core/UserSession'
import { Record } from 'immutable'
import SessionEvent from '../event/SessionEvent'

const Session = Record({
  isOwner: false,
  rooms: []
})

class SessionStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new Session()
  }

  reduce(state, action) {
    switch (action.type) {
      case SessionEvent.loginSuccess:
        if (action.payload.token) {
          // トークンがあった場合は Cookie に書き込む
          UserSession.write(action.payload.token)
        }

        let isOwner = false
        if (action.payload.user && action.payload.user.is_owner) {
          isOwner = action.payload.user.is_owner
        }

        let rooms = []
        if (action.payload.rooms) {
          rooms = action.payload.rooms
        }

        return state.merge({
          isOwner: isOwner,
          rooms: rooms
        })

      default:
        return state
    }
  }
}

export default new SessionStore()
